const translations = {
    reportName: 'AcreConnect  |  Product Usage Report'
};

export default translations;
